import { useState } from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import LogoBar from "@/components/sections/LogoBar";
import Services from "@/components/sections/Services";
import About from "@/components/sections/About";
import Process from "@/components/sections/Process";
import Stats from "@/components/sections/Stats";
import ClientLogos from "@/components/sections/ClientLogos";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

const LandingPage = () => {
  const [contactPrefill, setContactPrefill] = useState(null);

  const handleSelectService = (service) => {
    setContactPrefill({ service });
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="landing-page" className="bg-white text-slate-900">
      <Navbar />
      <Hero />
      <LogoBar />
      <Services onSelectService={handleSelectService} />
      <About />
      <Process />
      <Stats />
      <ClientLogos />
      <FAQ />
      <Contact prefill={contactPrefill} />
      <Footer />
    </div>
  );
};

export default LandingPage;
